const UPLOAD_STEPS = {
  PENDING: 'PENDING',
  UPLOADING: 'UPLOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export default UPLOAD_STEPS;
